import { useEffect, useState } from "react";
import styled from "styled-components";
import NavItems from "./NavItems";
import Socials from "./Socials";

const StyledHamburger = styled.button`
  position: relative;
  display: none;
  flex-direction: column;
  justify-content: space-between;
  height: 2.3rem;
  width: 3.2rem;
  z-index: 2;
  transition: transform 0.2s;

  @media only screen and (max-width: 750px) {
    display: flex;
    margin-right: 0;
  }

  @media only screen and (min-width: 601px) and (max-width: 1200px) {
    display: flex;
  }

  &:hover {
    transform: scale(1.1);
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 3px;
  }
`;

interface LineProps {
  open: boolean;
  right?: boolean;
  middle?: boolean;
}

const Line = styled.div`
  width: 100%;
  height: 3px;
  border-radius: 1px;
  background-color: var(--primary);
  transition: all 0.3s;

  transform: ${(props: LineProps) =>
    !props.open
      ? "rotate(0deg)"
      : props.right
      ? "rotate(-45deg) translate(0.7rem, -0.7rem)"
      : "rotate(45deg) translate(0.7rem, 0.7rem)"};
  opacity: ${(props: LineProps) => (props.open && props.middle ? "0" : "1")};

  ${StyledHamburger}:hover & {
    background-color: black;
  }
`;

interface SliderProps {
  open: boolean;
}

const Slider = styled.div`
  position: fixed;
  z-index: 999;
  top: var(--site-header-height);
  left: 0;
  width: 100vw;
  height: calc(100svh - var(--site-header-height));
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--bg);
  padding-top: 2rem;
  padding-bottom: 3rem;
  overflow-y: auto;

  /* visibility keeps the closed menu's links out of the tab order */
  visibility: ${(props: SliderProps) => (props.open ? "visible" : "hidden")};
  transition: transform 0.3s, visibility 0.3s;
  transform: ${(props: SliderProps) =>
    props.open ? "translateX(0)" : "translateX(100%)"};
`;

const Hamburger = () => {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  useEffect(() => {
    if (!open) return;
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [open]);

  return (
    <>
      <Slider open={open} aria-hidden={!open}>
        <NavItems onNavigate={close} />
        <Socials />
      </Slider>
      <StyledHamburger
        onClick={() => setOpen(!open)}
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
      >
        <Line open={open} />
        <Line middle open={open} />
        <Line right open={open} />
      </StyledHamburger>
    </>
  );
};

export default Hamburger;
